/**
 * @desc 前往出价时的身份验证
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CheckIdentityAuthenticationParameter = {
  auctionId?: string
}

const method = 'GET'
const url = '/trade/mall/auction/identityAuthentication'

export const checkIdentityAuthenticationApi = (
  params?: CheckIdentityAuthenticationParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<boolean>({
    method,
    url,
    params,
    ...config
  })
}

checkIdentityAuthenticationApi.method = method
checkIdentityAuthenticationApi.url = url
